import './index.css';
import config, { stage } from 'config';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { MemoryRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { Event, EventHint, init, ErrorBoundary } from '@sentry/react';
// App
import App from 'app/App';
import Fallback from 'Fallback';
// Service
import StorageService from 'services/Storage.service';
// Store
import store from 'store';

StorageService.getDataFromUrl();

const slug = StorageService.getSlug();

const entries:string[] = [`/quiz/${slug}/live-leaderboard`, `/quiz/${slug}/live-results`, `/quiz/${slug}/live-teamboard`, `/quiz/${slug}`, `/quiz-group/${slug}/live-leaderboard`, `/quiz-group/${slug}`];
const { pathname } = window.location;
const routeIndex = entries.findIndex(e => pathname.startsWith(e));

const isStageOrProd = stage === 'staging' || stage === 'production';

if (isStageOrProd) {
  init({
    dsn: config.sentryDsn,
    sendDefaultPii: true,
    environment: stage,
    beforeSend(event: Event, hint: EventHint) {
      const message = (hint?.originalException as any)?.message || '';
      const name = (hint?.originalException as any)?.name || '';
    
      if (
        typeof message === 'string' &&
        (
          message.includes('Invalid call to runtime.sendMessage') ||
          message.includes('Tab not found') ||
          message.includes('Extension context invalidated') ||
          message.includes('The request is not allowed by the user agent') ||
          message.includes('The object can not be found here.')
        )
      ) {
        return null;
      }
    
      if (name === 'NotAllowedError' || name === 'NotFoundError') {
        return null;
      }
    
      event.extra = { ...(event.extra || {}) };
    
      if (
        hint &&
        hint.originalException &&
        typeof hint.originalException === 'object' &&
        hint.originalException !== null
      ) {
        try {
          const keys = Object.keys(hint.originalException);
          if (keys.length) {
            (event.extra as any).errorProperties = {};
            keys.forEach(key => {
              (event.extra as any).errorProperties[key] = (hint.originalException as any)[key];
            });
          }
        } catch (error) {
          console.warn('[sentry] Failed to assign enumerable error properties to extras', error);
        }
      }
    
      return event;
    }
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <MemoryRouter
        initialEntries={entries}
        initialIndex={routeIndex}
      >
        <ErrorBoundary fallback={<Fallback />}>
          <App />
        </ErrorBoundary>
      </MemoryRouter>
    </Provider>
  // </React.StrictMode>
);
